import React, {FC} from 'react';
import './style.scss';
import PopularMixesCard from "../PopularMixesCard";
import Slider from "react-slick";
import {useHistory} from 'react-router-dom';
import {IMix} from "../../../constants/types";

interface IPopularMixes {
    popularMixes: Array<IMix>,
    setTobaccoIndex: any
}

const PopularMixes: FC<IPopularMixes> = ({popularMixes, setTobaccoIndex}) => {

    const history = useHistory();

    const settings = {
        slidesToScroll: 4,
        slidesToShow: 4,
        infinite: false,
        arrows: false,
        speed: 1000
    };

    const clickHandler = (id?: number) => {
        const clickIndex = popularMixes.findIndex((item: { id: number }) => item && item.id === id);
        setTobaccoIndex(clickIndex);
        history.push('/main/popular-mixes/:' + clickIndex);
    };
    return (
        <div className="popular-mixes">
            <div className="popular-mixer__container">
                <div className="popular-mixes__header">
                    <div className="popular-mixes__title">
                        Популярные миксы
                    </div>
                    <div className="popular-mixes__all"
                         onClick={() => history.push('/main/popular-mixes')}>
                        См. все
                    </div>
                </div>
                <div className="mix-week-popular__cards">
                    <Slider {...settings} >
                        {
                            popularMixes.map((item: any, index: number) => {
                                return (
                                    <PopularMixesCard
                                        key={index}
                                        onClick={() => clickHandler(item.id)}
                                        imageUrl={item.imageUrl}
                                        name={item.name}
                                        description={item.tobaccos[0].description}
                                    />
                                )
                            })
                        }
                    </Slider>
                </div>
            </div>
        </div>
    )
};

export default PopularMixes;
